import { Button, Modal, Table } from '@vwfs-bronson/bronson-react';
import { useState } from 'react';
import { UnclaimedInstallation } from '../fes';

const dateFormatter = new Intl.DateTimeFormat('en-GB', {
  dateStyle: 'medium',
  timeStyle: 'short',
});

function formatDateTime(value: string | undefined): string {
  if (!value) return '-';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : dateFormatter.format(date);
}

export function GitHubAppsTable({ installations }: { installations: UnclaimedInstallation[] }) {
  const [repositoryInstallation, setRepositoryInstallation] = useState<UnclaimedInstallation>();

  if (installations.length === 0) {
    return (
      <div className="app-empty-state">
        <strong>No unassigned GitHub App installations</strong>
        <p>Installations already connected to a team are managed from the Teams page.</p>
      </div>
    );
  }

  return (
    <>
      <div className="app-table-wrap">
        <Table className="app-table" colored>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Installation ID</Table.Th>
              <Table.Th>Account Login</Table.Th>
              <Table.Th>Account ID</Table.Th>
              <Table.Th>Account Type</Table.Th>
              <Table.Th>Repositories</Table.Th>
              <Table.Th>Created At</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {installations.map(installation => {
              const repositories = installation.repositories ?? [];

              return (
                <Table.Tr key={installation.installationId}>
                  <Table.Td>{installation.installationId}</Table.Td>
                  <Table.Td>{installation.accountLogin}</Table.Td>
                  <Table.Td>{installation.accountId}</Table.Td>
                  <Table.Td>{installation.accountType || '-'}</Table.Td>
                  <Table.Td>
                    {repositories.length === 0 ? '-' : (
                      <Button
                        className="app-repository-button"
                        icon="semantic-forward"
                        onClick={() => setRepositoryInstallation(installation)}
                        secondary
                        small
                      >
                        View {repositories.length} {repositories.length === 1 ? 'repository' : 'repositories'}
                      </Button>
                    )}
                  </Table.Td>
                  <Table.Td title={installation.createdAt}>{formatDateTime(installation.createdAt)}</Table.Td>
                </Table.Tr>
              );
            })}
          </Table.Tbody>
        </Table>
      </div>

      {repositoryInstallation ? (
        <Modal
          buttonCloseLabel="Close repository list"
          buttonConfirmText="Close"
          className="app-repository-modal"
          onClose={() => setRepositoryInstallation(undefined)}
          onConfirm={() => setRepositoryInstallation(undefined)}
          shown
          title={`Repositories for ${repositoryInstallation.accountLogin}`}
        >
          <p className="app-modal-copy">
            {repositoryInstallation.repositories?.length ?? 0}{' '}
            {(repositoryInstallation.repositories?.length ?? 0) === 1 ? 'repository' : 'repositories'} available to this installation.
          </p>
          <div className="app-table-wrap">
            <Table className="app-table" colored>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>Repository</Table.Th>
                  <Table.Th>Visibility</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {(repositoryInstallation.repositories ?? []).map(repository => (
                  <Table.Tr key={repository.id}>
                    <Table.Td>{repository.full_name}</Table.Td>
                    <Table.Td>{repository.private ? 'Private' : 'Public'}</Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
          </div>
        </Modal>
      ) : null}
    </>
  );
}
